// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UIFieldComponentsLibrary.module.css */

.UIFieldComponentsLibrary_libraryWrapper__RmXcJ {
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 100vh;
  background: #f9fafb;
}

.UIFieldComponentsLibrary_headerRow__Hp5i4 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.UIFieldComponentsLibrary_titleSection__pfdIU {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.UIFieldComponentsLibrary_title__2HYwG {
  font-size: 22px;
  font-weight: 600;
  color: #121723;
  margin: 0;
}

.UIFieldComponentsLibrary_subtitle__VaqPp {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  max-width: 720px;
  line-height: 1.5;
}

.UIFieldComponentsLibrary_versionChip__VvcN\\+ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #4a7feb;
  background: #eef3ff;
  padding: 4px 10px;
  border-radius: 12px;
  border: 1px solid #dce7ff;
}

.UIFieldComponentsLibrary_primaryBtn__OleTG {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #4a7feb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.UIFieldComponentsLibrary_primaryBtn__OleTG:hover {
  background: #3a6fd4;
}

.UIFieldComponentsLibrary_primaryBtn__OleTG:disabled {
  background: #b6c6e6;
  cursor: not-allowed;
}

.UIFieldComponentsLibrary_secondaryBtn__Q-MWX {
  background: transparent;
  color: #4a7feb;
  border: 1px solid #4a7feb;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.UIFieldComponentsLibrary_secondaryBtn__Q-MWX:hover {
  background: #f0f5ff;
}

.UIFieldComponentsLibrary_dangerBtn__ATWz7 {
  background: transparent;
  color: #dc2626;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.UIFieldComponentsLibrary_dangerBtn__ATWz7:hover {
  background: #fef2f2;
}

/* Component cards grid */
.UIFieldComponentsLibrary_grid__jivfR {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.UIFieldComponentsLibrary_card__rO1C3 {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.UIFieldComponentsLibrary_card__rO1C3:hover {
  border-color: #c7d7fb;
  box-shadow: 0 2px 8px rgba(74, 127, 235, 0.08);
}

.UIFieldComponentsLibrary_cardHeader__CugpV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.UIFieldComponentsLibrary_cardName__dn4ap {
  font-size: 15px;
  font-weight: 600;
  color: #121723;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.UIFieldComponentsLibrary_typeBadge__0qID9 {
  font-size: 11px;
  font-weight: 600;
  color: #4a7feb;
  background: #eef3ff;
  padding: 3px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.UIFieldComponentsLibrary_cardMeta__EkZ4C {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #6b7280;
}

.UIFieldComponentsLibrary_cardMetaRow__Frmnn {
  display: flex;
  gap: 6px;
  align-items: baseline;
}

.UIFieldComponentsLibrary_cardMetaLabel__pP3CE {
  font-weight: 500;
  color: #374151;
  min-width: 82px;
}

.UIFieldComponentsLibrary_optionPreview__iB55a {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.UIFieldComponentsLibrary_optionChip__oxSnK {
  font-size: 11px;
  color: #4b5563;
  background: #f3f4f6;
  padding: 2px 7px;
  border-radius: 8px;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.UIFieldComponentsLibrary_optionChipMore__1EiaX {
  font-size: 11px;
  color: #4a7feb;
  background: #eef3ff;
  padding: 2px 7px;
  border-radius: 8px;
}

.UIFieldComponentsLibrary_cardActions__1JOpd {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.UIFieldComponentsLibrary_iconBtn__8YYbc {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #4b5563;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.UIFieldComponentsLibrary_iconBtn__8YYbc:hover {
  border-color: #4a7feb;
  color: #4a7feb;
}

.UIFieldComponentsLibrary_iconBtnDanger__-8g5Y:hover {
  border-color: #dc2626;
  color: #dc2626;
}

/* Empty state */
.UIFieldComponentsLibrary_emptyState__2bhEU {
  background: #ffffff;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 48px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.UIFieldComponentsLibrary_emptyTitle__Q9QD8 {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.UIFieldComponentsLibrary_emptyText__YGbcq {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  max-width: 480px;
  line-height: 1.6;
}

/* Editor modal */
.UIFieldComponentsLibrary_modalOverlay__IX9gk {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.UIFieldComponentsLibrary_modal__etibI {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.UIFieldComponentsLibrary_modalHeader__h\\+oqo {
  padding: 18px 22px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.UIFieldComponentsLibrary_modalTitle__pLe4S {
  font-size: 16px;
  font-weight: 600;
  color: #121723;
  margin: 0;
}

.UIFieldComponentsLibrary_modalClose__kbWvn {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
}

.UIFieldComponentsLibrary_modalClose__kbWvn:hover {
  color: #121723;
}

.UIFieldComponentsLibrary_modalBody__UmC09 {
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

.UIFieldComponentsLibrary_fieldGroup__39zEu {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.UIFieldComponentsLibrary_fieldLabel__8iNl8 {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.UIFieldComponentsLibrary_required__IG-a2 {
  color: #dc2626;
  margin-left: 2px;
}

.UIFieldComponentsLibrary_fieldInput__6aor3,
.UIFieldComponentsLibrary_fieldSelect__rkJcC,
.UIFieldComponentsLibrary_fieldTextarea__eLC-C {
  width: 100%;
  font-size: 13px;
  padding: 9px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff;
  color: #121723;
  box-sizing: border-box;
  font-family: inherit;
}

.UIFieldComponentsLibrary_fieldTextarea__eLC-C {
  resize: vertical;
  min-height: 90px;
  font-family: ui-monospace, "SFMono-Regular", Menlo, monospace;
}

.UIFieldComponentsLibrary_fieldInput__6aor3:focus,
.UIFieldComponentsLibrary_fieldSelect__rkJcC:focus,
.UIFieldComponentsLibrary_fieldTextarea__eLC-C:focus {
  outline: none;
  border-color: #4a7feb;
  box-shadow: 0 0 0 3px rgba(74, 127, 235, 0.15);
}

.UIFieldComponentsLibrary_helperText__55rfz {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
}

.UIFieldComponentsLibrary_errorText__ml-Zg {
  font-size: 12px;
  color: #dc2626;
  margin: 0;
}

.UIFieldComponentsLibrary_optionRow__LV-fH {
  display: flex;
  gap: 8px;
  align-items: center;
}

.UIFieldComponentsLibrary_optionRow__LV-fH input {
  flex: 1 1;
}

.UIFieldComponentsLibrary_optionRowRemove__HmThv {
  background: transparent;
  border: none;
  color: #dc2626;
  font-size: 16px;
  cursor: pointer;
  padding: 4px 8px;
}

.UIFieldComponentsLibrary_modalActions__TSF51 {
  padding: 16px 22px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.UIFieldComponentsLibrary_cancelBtn__c-2C7 {
  background: transparent;
  color: #4b5563;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.UIFieldComponentsLibrary_cancelBtn__c-2C7:hover {
  background: #f9fafb;
}

.UIFieldComponentsLibrary_saveBtn__b-Hgq {
  background: #4a7feb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.UIFieldComponentsLibrary_saveBtn__b-Hgq:hover {
  background: #3a6fd4;
}

.UIFieldComponentsLibrary_saveBtn__b-Hgq:disabled {
  background: #b6c6e6;
  cursor: not-allowed;
}

.UIFieldComponentsLibrary_loadingWrap__1lOl3 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.UIFieldComponentsLibrary_errorBanner__jdnjZ {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/UIFieldComponentsLibrary/UIFieldComponentsLibrary.module.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB","sourcesContent":["/* UIFieldComponentsLibrary.module.css */\n\n.libraryWrapper {\n  padding: 24px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-height: 100vh;\n  background: #f9fafb;\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.titleSection {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #121723;\n  margin: 0;\n}\n\n.subtitle {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n  max-width: 720px;\n  line-height: 1.5;\n}\n\n.versionChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #4a7feb;\n  background: #eef3ff;\n  padding: 4px 10px;\n  border-radius: 12px;\n  border: 1px solid #dce7ff;\n}\n\n.primaryBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #4a7feb;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.primaryBtn:hover {\n  background: #3a6fd4;\n}\n\n.primaryBtn:disabled {\n  background: #b6c6e6;\n  cursor: not-allowed;\n}\n\n.secondaryBtn {\n  background: transparent;\n  color: #4a7feb;\n  border: 1px solid #4a7feb;\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.secondaryBtn:hover {\n  background: #f0f5ff;\n}\n\n.dangerBtn {\n  background: transparent;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.dangerBtn:hover {\n  background: #fef2f2;\n}\n\n/* Component cards grid */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.card:hover {\n  border-color: #c7d7fb;\n  box-shadow: 0 2px 8px rgba(74, 127, 235, 0.08);\n}\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.cardName {\n  font-size: 15px;\n  font-weight: 600;\n  color: #121723;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.typeBadge {\n  font-size: 11px;\n  font-weight: 600;\n  color: #4a7feb;\n  background: #eef3ff;\n  padding: 3px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.cardMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.cardMetaRow {\n  display: flex;\n  gap: 6px;\n  align-items: baseline;\n}\n\n.cardMetaLabel {\n  font-weight: 500;\n  color: #374151;\n  min-width: 82px;\n}\n\n.optionPreview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.optionChip {\n  font-size: 11px;\n  color: #4b5563;\n  background: #f3f4f6;\n  padding: 2px 7px;\n  border-radius: 8px;\n  max-width: 110px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.optionChipMore {\n  font-size: 11px;\n  color: #4a7feb;\n  background: #eef3ff;\n  padding: 2px 7px;\n  border-radius: 8px;\n}\n\n.cardActions {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.iconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  color: #4b5563;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.iconBtn:hover {\n  border-color: #4a7feb;\n  color: #4a7feb;\n}\n\n.iconBtnDanger:hover {\n  border-color: #dc2626;\n  color: #dc2626;\n}\n\n/* Empty state */\n.emptyState {\n  background: #ffffff;\n  border: 1px dashed #d1d5db;\n  border-radius: 10px;\n  padding: 48px 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n}\n\n.emptyTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n.emptyText {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n  max-width: 480px;\n  line-height: 1.6;\n}\n\n/* Editor modal */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal {\n  background: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modalHeader {\n  padding: 18px 22px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #121723;\n  margin: 0;\n}\n\n.modalClose {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  padding: 4px;\n}\n\n.modalClose:hover {\n  color: #121723;\n}\n\n.modalBody {\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.fieldLabel {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.required {\n  color: #dc2626;\n  margin-left: 2px;\n}\n\n.fieldInput,\n.fieldSelect,\n.fieldTextarea {\n  width: 100%;\n  font-size: 13px;\n  padding: 9px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #121723;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.fieldTextarea {\n  resize: vertical;\n  min-height: 90px;\n  font-family: ui-monospace, \"SFMono-Regular\", Menlo, monospace;\n}\n\n.fieldInput:focus,\n.fieldSelect:focus,\n.fieldTextarea:focus {\n  outline: none;\n  border-color: #4a7feb;\n  box-shadow: 0 0 0 3px rgba(74, 127, 235, 0.15);\n}\n\n.helperText {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.errorText {\n  font-size: 12px;\n  color: #dc2626;\n  margin: 0;\n}\n\n.optionRow {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.optionRow input {\n  flex: 1;\n}\n\n.optionRowRemove {\n  background: transparent;\n  border: none;\n  color: #dc2626;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 4px 8px;\n}\n\n.modalActions {\n  padding: 16px 22px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.cancelBtn {\n  background: transparent;\n  color: #4b5563;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 9px 18px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.cancelBtn:hover {\n  background: #f9fafb;\n}\n\n.saveBtn {\n  background: #4a7feb;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.saveBtn:hover {\n  background: #3a6fd4;\n}\n\n.saveBtn:disabled {\n  background: #b6c6e6;\n  cursor: not-allowed;\n}\n\n.loadingWrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n}\n\n.errorBanner {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"libraryWrapper": `UIFieldComponentsLibrary_libraryWrapper__RmXcJ`,
	"headerRow": `UIFieldComponentsLibrary_headerRow__Hp5i4`,
	"titleSection": `UIFieldComponentsLibrary_titleSection__pfdIU`,
	"title": `UIFieldComponentsLibrary_title__2HYwG`,
	"subtitle": `UIFieldComponentsLibrary_subtitle__VaqPp`,
	"versionChip": `UIFieldComponentsLibrary_versionChip__VvcN+`,
	"primaryBtn": `UIFieldComponentsLibrary_primaryBtn__OleTG`,
	"secondaryBtn": `UIFieldComponentsLibrary_secondaryBtn__Q-MWX`,
	"dangerBtn": `UIFieldComponentsLibrary_dangerBtn__ATWz7`,
	"grid": `UIFieldComponentsLibrary_grid__jivfR`,
	"card": `UIFieldComponentsLibrary_card__rO1C3`,
	"cardHeader": `UIFieldComponentsLibrary_cardHeader__CugpV`,
	"cardName": `UIFieldComponentsLibrary_cardName__dn4ap`,
	"typeBadge": `UIFieldComponentsLibrary_typeBadge__0qID9`,
	"cardMeta": `UIFieldComponentsLibrary_cardMeta__EkZ4C`,
	"cardMetaRow": `UIFieldComponentsLibrary_cardMetaRow__Frmnn`,
	"cardMetaLabel": `UIFieldComponentsLibrary_cardMetaLabel__pP3CE`,
	"optionPreview": `UIFieldComponentsLibrary_optionPreview__iB55a`,
	"optionChip": `UIFieldComponentsLibrary_optionChip__oxSnK`,
	"optionChipMore": `UIFieldComponentsLibrary_optionChipMore__1EiaX`,
	"cardActions": `UIFieldComponentsLibrary_cardActions__1JOpd`,
	"iconBtn": `UIFieldComponentsLibrary_iconBtn__8YYbc`,
	"iconBtnDanger": `UIFieldComponentsLibrary_iconBtnDanger__-8g5Y`,
	"emptyState": `UIFieldComponentsLibrary_emptyState__2bhEU`,
	"emptyTitle": `UIFieldComponentsLibrary_emptyTitle__Q9QD8`,
	"emptyText": `UIFieldComponentsLibrary_emptyText__YGbcq`,
	"modalOverlay": `UIFieldComponentsLibrary_modalOverlay__IX9gk`,
	"modal": `UIFieldComponentsLibrary_modal__etibI`,
	"modalHeader": `UIFieldComponentsLibrary_modalHeader__h+oqo`,
	"modalTitle": `UIFieldComponentsLibrary_modalTitle__pLe4S`,
	"modalClose": `UIFieldComponentsLibrary_modalClose__kbWvn`,
	"modalBody": `UIFieldComponentsLibrary_modalBody__UmC09`,
	"fieldGroup": `UIFieldComponentsLibrary_fieldGroup__39zEu`,
	"fieldLabel": `UIFieldComponentsLibrary_fieldLabel__8iNl8`,
	"required": `UIFieldComponentsLibrary_required__IG-a2`,
	"fieldInput": `UIFieldComponentsLibrary_fieldInput__6aor3`,
	"fieldSelect": `UIFieldComponentsLibrary_fieldSelect__rkJcC`,
	"fieldTextarea": `UIFieldComponentsLibrary_fieldTextarea__eLC-C`,
	"helperText": `UIFieldComponentsLibrary_helperText__55rfz`,
	"errorText": `UIFieldComponentsLibrary_errorText__ml-Zg`,
	"optionRow": `UIFieldComponentsLibrary_optionRow__LV-fH`,
	"optionRowRemove": `UIFieldComponentsLibrary_optionRowRemove__HmThv`,
	"modalActions": `UIFieldComponentsLibrary_modalActions__TSF51`,
	"cancelBtn": `UIFieldComponentsLibrary_cancelBtn__c-2C7`,
	"saveBtn": `UIFieldComponentsLibrary_saveBtn__b-Hgq`,
	"loadingWrap": `UIFieldComponentsLibrary_loadingWrap__1lOl3`,
	"errorBanner": `UIFieldComponentsLibrary_errorBanner__jdnjZ`
};
export default ___CSS_LOADER_EXPORT___;
